define('bizzabo/views/EventBriteConnectView',[
    'jquery',
    'backbone',
    'bizzabo/bzapi',
    'bizzabo/consts',
    'bizzabo/config',
    'bizzabo/models/Global',
    'bizzabo/models/EventDetails',
    'bizzabo/models/ExternalEventsCollection',
    'bizzabo/views/ExternalEventsListView',
    'bizzabo/views/popup/PopupView',
    'hbars!bizzabo/templates/eventBriteConnect'
], function(
    $,
    Backbone,
    BZAPI,
    Consts,
    CONFIG,
    Global,
    EventDetails,
    ExternalEventsCollection,
    ExternalEventsListView,
    PopupView,
    template
    ) {

    var EventBriteConnectView = PopupView.extend({

        events : {
            'click a.tryagain' : 'tryAgain'
        },

        className : 'eventBriteConnect',
        eventsCollection : undefined,
        eventsView : undefined,

        initialize : function() {
            this.popUpInitialize();
            this.me = Global.modelPool.getMe();
            this.event = Global.modelPool.getActiveEvent();
            this.listenTo(Backbone, Consts.Notifications.eventBrite.OAUTH_SUCCESS, this.finishedWithSuccess);
            this.listenTo(Backbone, Consts.Notifications.eventBrite.OAUTH_FAILURE, this.finishedWithFailure);
            this.listenTo(Backbone, 'connect-event-clicked', this.connectEventClicked);
            this.model = new Backbone.Model({
                appkey : CONFIG.EVENTBRITE_KEY,
                hasToken : this.me.has('external-ids-eventbrite')
            });
        },

        remove : function() {
            this.eventsView && this.eventsView.remove();
            this.eventsCollection && this.eventsCollection.remove();
            this.stopListening();
            this.popupRemove();
            return this;
        },

        adjustModalSize : function(animated) {
            var css = {height: 'auto'};
            if (animated) {
                var thisView = this;
                thisView.$el.animate({
                    height: '160px'
                }, 400, function() {
                    thisView.$el.css(css);
                });
            } else {
                this.$el.css(css);
            }
        },

        showLoading : function(show) {
            if (show) {
                this.$(".eventBriteConnectContent").slideUp('fast');
                this.$(".loading").fadeIn('fast');
            } else {
                this.$(".eventBriteConnectContent").slideDown('fast');
                this.$(".loading").fadeOut('fast');
            }
        },

        showErrorMessage : function(show) {
            if (show) {
                this.$(".eventBriteConnectContent").slideUp('fast');
                this.$(".errormessage").slideDown('fast');
            } else {
                this.$(".eventBriteConnectContent").slideDown('fast');
                this.$(".errormessage").slideUp('fast');
            }
        },

        importEvents : function(animated) {
            this.adjustModalSize(animated);

            this.eventsCollection = new ExternalEventsCollection();
            this.eventsCollection.provider = 'eventbrite';

            var thisView = this;
            thisView.showLoading(true);
            this.eventsCollection.fetch({
                success : function() {
                    Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                        category : 'Organizer Responses',
                        action : 'Events imported from Eventbrite'
                    });

                    thisView.showLoading(false);
                    var numberOfImportedEvents = thisView.eventsCollection.length;
                    thisView.model.set({
                        numberOfImportedEvents : numberOfImportedEvents,
                        hasEvents : (numberOfImportedEvents > 0)
                    });
                    thisView.render();
                    if (thisView.model.get('hasEvents')) {
                        thisView.eventsView = new ExternalEventsListView({
                            model : thisView.eventsCollection,
                            el : thisView.$('ul.importedEvents')
                        }).render();
                    }
                },
                error : function(originalModel, errorCode) {
                    thisView.showLoading(false);
                    thisView.showErrorMessage(true);
                }
            });
        },

        connectEventClicked: function(event) {
            var thisView = this;
            this.event.save({
                'source': event.get('source'),
                'source-id': event.get('source-id'),
                'source-event-name': event.get('name')
            }, {
                success: function() {
                    Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                        msg : 'Your event was successfully connected',
                        errorLevelClass : Consts.UI.notificationMsgs.errorLevelsClasses.SUCCESS,
                        autoHide : true
                    });
                    thisView.event.enablePollingRegistrationSystem();
                },
                error : function(model, errorCode) {
                    if (errorCode == BZAPI.errorCodes.SourceIsAlreadyTaken) {
                        Backbone.trigger(Consts.Notifications.notificationMsgs.TRIGGER_NOTIFICATION_MSG, {
                            msg : 'This Eventbrite event is already connected to another Bizzabo event. Please contact us for help.',
                            showOkBtn : true,
                            okBtnText : 'Contact us',
                            okCallBack : function() {
                                thisView.event.unset('source');
                                thisView.event.unset('source-id');
                                thisView.event.unset('source-event-name');
                                thisView.contactUs('Eventbrite connect issue');
                            }
                        });
                    }
                }
            });
            this.hide();
        },

        contactUs : function(problem) {
            var me = Global.modelPool.getMe();
            var params = [];
            params.push('interaction[name]=' + encodeURIComponent(me.get('full-name')));
            params.push('interaction[email]=' + encodeURIComponent(me.get('primary-email')));
            params.push('customer[company]=' + encodeURIComponent(me.get('company')));
            params.push('customer[custom1]=' + encodeURIComponent(me.get('country')));
            params.push('email[subject]=Can\'t%20save%20my%20event%20(' + problem + ')');
            var queryParams = params.join('&');
            window.open('http://help.bizzabo.com/customer/portal/emails/new?' + queryParams);
        },

        tryAgain : function() {
            this.model.set('hasToken', false);
            this.render();
            if (!this.model.get('hasToken')) {
                var url = CONFIG.DASHBOARD_URL + '/auth/eventbrite?next=' +encodeURIComponent(CONFIG.ORGANIZER_URL +'/eventbrite.html#redirect');

                this.oauthWindow = window.open(url, 'name');
            }
        },

        finishedWithSuccess : function(accessToken) {
            this.oauthWindow && this.oauthWindow.close();
            var thisView = this;
            this.me.saveEventBriteAccessToken(accessToken, function() {
                thisView.model.set('hasToken', true);
                thisView.render();
                thisView.importEvents(true);
            }, function() {
                thisView.hide();
            });
        },

        finishedWithFailure : function() {
            this.oauthWindow && this.oauthWindow.close();
            this.hide();
        },

        viewRendered : function() {
            if (this.model.get('hasToken')) {
                this.importEvents(false);
            }
        },

        render : function() {
            var html = template(this.model.toJSON());
            this.$el.html(html);
            return this;
        }

    });

    return EventBriteConnectView;

});

